import PropTypes from "prop-types";
import styles from "./quantity-selector.module.less";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";
import { Icon } from "@parksandresorts/core";

const QuantitySelector = (props) => {
  const {
    quantity,
    minQuantity,
    maxQuantity,
    isMaxQuantityReached,
    productName,
    description,
    onQuantityChanged,
    classNameLeftButton,
    classNameRightButton,
  } = props;
  const _isMinQuantityReached = typeof minQuantity === "number" && quantity <= minQuantity;
  const _isMaxQuantityReached = (typeof maxQuantity === "number" && quantity >= maxQuantity) || isMaxQuantityReached;
  const onClickChangeQuantity = (modifiedQuantity) => {
    if (!(onQuantityChanged && typeof onQuantityChanged === "function")) {
      return;
    }
    if (typeof minQuantity === "number" && modifiedQuantity < minQuantity) {
      return;
    }
    if (typeof maxQuantity === "number" && modifiedQuantity > maxQuantity) {
      return;
    }
    onQuantityChanged(modifiedQuantity);
  };
  const getInteractionProps = (isDisabled) => {
    return !isDisabled
      ? {
          whileTap: { scale: 0.9 },
          whileHover: { scale: 1.03 },
        }
      : undefined;
  };
  return (
    <div className={[styles.wrapper, props.wrapperClassName].join(" ")}>
      <motion.button
        disabled={_isMinQuantityReached}
        {...getInteractionProps(_isMinQuantityReached)}
        onClick={() => onClickChangeQuantity(quantity - 1)}
        className={`${styles.button} ${styles.buttonDecrease} ${classNameLeftButton}`}
      >
        <Icon name="remove" className={styles.icon} size="l" />
      </motion.button>
      <span className={styles.textWrapper}>
        <span className={styles.quantityWrapper}>
          <span className={styles.quantity}>{quantity}</span>
          <span className={styles.productName}>{productName}</span>
        </span>
        {description && <span className={styles.description}>{description}</span>}
      </span>
      <motion.button
        disabled={_isMaxQuantityReached}
        {...getInteractionProps(_isMaxQuantityReached)}
        onClick={() => onClickChangeQuantity(quantity + 1)}
        className={`${styles.button} ${styles.buttonIncrease} ${classNameRightButton}`}
      >
        <Icon name="add" className={styles.icon} size="l" />
      </motion.button>
    </div>
  );
};
QuantitySelector.defaultProps = {
  minQuantity: 1,
};
QuantitySelector.propTypes = {
  minQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  quantity: PropTypes.number.isRequired,
  productName: PropTypes.string,
  description: PropTypes.string,
  onQuantityChanged: PropTypes.func,
  wrapperClassName: PropTypes.string,
};
export default QuantitySelector;
